export const relativeModel = ({ id, first_name, last_name }) => {
  return {
    value: id,
    label: `${first_name} ${last_name}`,
  };
};
